import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import { uploadFilesToR2 } from "polaris-enhance"

import toast from "@/utils/toast"

/*
 * 导出文件流方法
 */

export const downloadBlobFile = (props) => {
  return new Promise((resolve, reject) => {
    try {
      const { blob, filename } = props
      // 创建Blob对象的URL
      const url = window.URL.createObjectURL(blob)

      // 创建一个<a>元素，设置下载链接
      const a = document.createElement("a")
      a.href = url
      a.download = filename

      // 将<a>元素添加到DOM中
      document.body.appendChild(a)

      // 模拟点击<a>元素进行下载
      a.click()

      // 清理
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)

      // 返回成功状态
      resolve({ status: "success", message: "Operation successful" })
    } catch (error) {
      // 返回失败状态
      reject({ status: "error", message: "Operation failed", error })
    }
  })
}

/*
 * 下载文件
 */

export const downloadFile = async (props) => {
  const { url, filename } = props

  return new Promise((resolve, reject) => {
    try {
      // 创建一个 <a> 元素
      const a = document.createElement("a")
      a.href = url // 设置链接地址
      a.download = filename // 可选：设置下载文件名

      // 将 <a> 元素添加到页面并触发点击
      document.body.appendChild(a)
      a.click()

      // 移除 <a> 元素，避免污染 DOM
      document.body.removeChild(a)

      // 返回成功状态
      resolve({
        status: "success",
        message: "Operation successful",
      })
    } catch (error) {
      // 返回失败状态
      reject({ status: "error", message: "Operation failed", error })
    }
  })
}

// 工具函数：将 HTML 转换为 PDF 并下载
export const downloadPDF = async (
  htmlContent,
  fileName = "download.pdf",
  isUploadOss = false,
  pdfWidth = 210,
  pdfHeight = 297,
) => {
  if (!htmlContent) {
    console.log("not find htmlContent")
    return
  }
  // 创建隐藏容器并插入 HTML 内容
  const container = document.createElement("div")
  container.innerHTML = htmlContent

  // 设置样式确保容器不被显示，但仍然可渲染
  Object.assign(container.style, {
    position: "absolute", // 脱离文档流
    top: "-9999px", // 将容器移出屏幕
    left: "-9999px", // 将容器移出屏幕
    width: `${pdfWidth * 8.8}px`, // 将 PDF 宽度转换为像素
    height: `${pdfHeight * 8.8}px`, // 将 PDF 高度转换为像素
  })

  document.body.appendChild(container)
  // document.body.appendChild(container)

  try {
    // 将 HTML 渲染为图片 （需要依赖安装 html2canvas 插件）
    const canvas = await html2canvas(container, { scale: 1 })
    const imgData = canvas.toDataURL("image/png")

    // 创建 PDF 文件并调整尺寸
    const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight])
    const imgWidth = pdfWidth // 图片按 PDF 宽度填充
    const imgHeight = (canvas.height * imgWidth) / canvas.width // 根据比例计算高度
    // const pdfWidth = pdf.internal.pageSize.getWidth()
    // const pdfHeight = (canvas.height * pdfWidth) / canvas.width

    // 添加图片到 PDF
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight)
    pdf.save(fileName) // 下载 PDF
    // toast("Operation successful", 5e3, false)
    let result: any = false

    // 是否上传Oss文档
    if (isUploadOss) {
      // 将 PDF 转换为文件对象
      const pdfBlob = pdf.output("blob")
      const pdfFile = new File([pdfBlob], "example.pdf", {
        type: "application/pdf",
      })
      result = await uploadFilesToR2([pdfFile])
    }

    return result
  } catch (error) {
    // console.error("PDF 下载失败:", error)
    toast("Operation failed", 5e3, true)
    return false
  } finally {
    // 清理容器
    document.body.removeChild(container)
  }
}
